import { ReactNode, useEffect, useState } from "react";
import Location1 from "assets/common/company/location1.png";
import Location2 from "assets/common/company/location2.png";
import Location3 from "assets/common/company/location3.png";
import Location4 from "assets/common/company/location4.png";
import Subway from "assets/common/company/subway.png";
import Station from "assets/common/company/station.png";
import Bus from "assets/common/company/bus.png";
import { useMediaQuery } from "hooks/utils/useMediaQuery";

const Map = ({ children }: { children: ReactNode }) => {
    const [renderKey, setRenderKey] = useState(0); // 리렌더링을 위한 key 값
    const responsive1200 = useMediaQuery(1200);

    useEffect(() => {
        if (responsive1200) {
            const resize = () => {
                setRenderKey(prevKey => prevKey + 1);
            };
            const ctrl = new AbortController();
            window.addEventListener("resize", resize, ctrl);
            return () => {
                ctrl.abort();
            };
        }
    }, [responsive1200]);

    return (
        <div className="w-full" key={renderKey}>
            {children}
        </div>
    );
};

const Location = () => {
    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-0 responsive1200:px-[4%]">
            <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">오시는길</p>
            <div className="bg-white w-full max-w-[1200px] p-[45px] flex flex-col items-center justify-center responsive1200:px-[4%]">
                <Map>
                    <iframe src="/map.html" title="카카오 지도" width="100%" height="510" style={{ border: 0 }} scrolling="no" />
                </Map>
                <div className="px-[20px] items-center mt-10 gap-y-[20px] gap-x-[20px] grid grid-cols-2 w-full responsive650:grid-cols-1">
                    <div className="flex items-center gap-10">
                        <img src={Location1} alt="Location1" />
                        <div>
                            <p className="text-[#333] font-semibold pb-[px]">ADDRESS</p>
                            <p className="text-[#666] text-[15px] break-keep">경기도 고양시 덕양구 행주산성로 214 일신빌딩</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-10">
                        <img src={Location2} alt="Location2" />
                        <div>
                            <p className="text-[#333] font-semibold pb-[px]">TEL</p>
                            <p className="text-[#666] text-[15px]">
                                대표전화 02-2661-4206 / <span className="text-[#3089dd] break-keep">고객센터 1588-0605</span>
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center  gap-10">
                        <img src={Location3} alt="Location3" />
                        <div>
                            <p className="text-[#333] font-semibold pb-[px]">FAX</p>
                            <p className="text-[#666] text-[15px] break-keep">031-971-4208</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-10">
                        <img src={Location4} alt="Location4" />
                        <div>
                            <p className="text-[#333] font-semibold pb-[px]">EMAIL</p>
                            <p className="text-[#666] text-[15px] break-keep">ilshinair@ilshinair.com</p>
                        </div>
                    </div>
                </div>

                {/* <div className="bg-back mt-12 w-full p-[40px] flex flex-col gap-8 responsive1200:px-[4%] responsive1200:py-[25px] responsive1200:gap-[25px]">
                    <div className="flex responsive1200:flex-col">
                        <div className="flex items-center">
                            <div className="border-[3px] rounded-full w-[76px] h-[76px] border-[#ddd] flex items-center justify-center shrink-0">
                                <img src={Subway} alt="Subway" />
                            </div>
                            <p className="text-[#333] text-[17px] pl-5 font-semibold w-[170px]">주변지하철</p>
                        </div>
                        <div className="text-[15px] text-[#666] flex gap-8 ml-8 responsive1200:ml-0 responsive1200:pt-[25px] responsive1200:flex-wrap responsive1200:gap-[3px]">
                            <div className="flex gap-3 items-center">
                                <div className="bg-[#8e47dd] rounded-full text-white w-5 h-5 flex items-center justify-center">5</div>
                                <p>개화산역 / 송정역 / 김포공항역</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="bg-[#ddb847] rounded-full text-white w-5 h-5 flex items-center justify-center">9</div>
                                <p>공항시장역 / 신방화역 / 김포공항역</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="bg-[#479cdd] rounded-full text-white w-10 h-5 flex items-center justify-center">공항</div>
                                <p>김포공항역</p>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="flex responsive1200:flex-col">
                        <div className="flex items-center">
                            <div className="border-[3px] rounded-full w-[76px] h-[76px] border-[#ddd] flex items-center justify-center shrink-0">
                                <img src={Station} alt="Station" />
                            </div>
                            <p className="text-[#333] text-[17px] pl-5 font-semibold w-[170px]">주변정류장</p>
                        </div>
                        <div className="text-[15px] text-[#666] flex gap-8 ml-8 responsive1200:ml-0 responsive1200:pt-[25px] responsive1200:flex-wrap responsive1200:gap-[3px]">
                            <div className="flex gap-3 items-center">
                                <div className="border border-[#999] text-[#999] rounded-full w-5 h-5 flex items-center justify-center">
                                    1
                                </div>
                                <p>공항고등학교 (84-014)</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="border border-[#999] text-[#999] rounded-full w-5 h-5 flex items-center justify-center">
                                    2
                                </div>
                                <p>공항고등학교 (16-376)</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="border border-[#999] text-[#999] rounded-full w-5 h-5 flex items-center justify-center">
                                    3
                                </div>
                                <p>방화중학교 (16-163)</p>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="flex responsive1200:flex-col">
                        <div className="flex items-center">
                            <div className="border-[3px] rounded-full w-[76px] h-[76px] border-[#ddd] flex items-center justify-center shrink-0">
                                <img src={Bus} alt="Bus" />
                            </div>
                            <p className="text-[#333] text-[17px] pl-5 font-semibold w-[170px]">주변버스</p>
                        </div>
                        <div className="text-[15px] text-[#666] flex gap-1.5 ml-8 flex-col ml-8 responsive1200:ml-0 responsive1200:pt-[25px] responsive1200:gap-[3px]">
                            <div>
                                <span className="bg-[#12b5a4] rounded-full text-white w-10 h-5 mr-[0.75rem] inline-flex items-center justify-center responsive1200:shrink-0">
                                    일반
                                </span>
                                <span>56, 71, 1002, 12, 150, 2, 3, 388, 50, 50-1, 60, 60-3, 69, 85-1, 88</span>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="bg-[#7c7feb] rounded-full text-white w-10 h-5 flex items-center justify-center">간선</div>
                                <p>300, 78, 66</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="bg-[#6bbe4e] rounded-full text-white w-10 h-5 flex items-center justify-center">지선</div>
                                <p>6642, 6645, 6647</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="bg-[#b96a55] rounded-full text-white w-10 h-5 flex items-center justify-center">공항</div>
                                <p>3700</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <div className="bg-[#479cdd] rounded-full text-white w-10 h-5 flex items-center justify-center">좌석</div>
                                <p>20, 21, 22, 85</p>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Location;
